import axios from 'axios';
const getDataByCodeApi = async (token , code , type) => {
    try {
        const res = await axios({
            method: 'get',
            baseURL: process.env.REACT_APP_BASE_TEST_URL,
            // baseURL: 'https://testclient-api.fatoorah.sa/apiAdmin/',
            url: `getToken`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'applications/json',
                Authorization: 'Bearer ' + token,
                lang: 'ar'
            },
            params: {
                code: code,
                type: type
            }
        });
    
        return res;
    } catch (error) {
        throw error;
    }
}

export default getDataByCodeApi;
